import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../services/api';

const PaymentSuccessPage = () => {
  const location = useLocation();
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const sessionId = new URLSearchParams(location.search).get('session_id');
    if (sessionId) {
      api.get(`/payments/checkout-session/${sessionId}`)
        .then(res => {
          setSession(res.data);
          setLoading(false);
        })
        .catch(err => {
          setError('Nie udało się pobrać informacji o sesji.');
          setLoading(false);
        });
    }
  }, [location]);

  if (loading) return <div className="text-center py-10">Weryfikowanie płatności...</div>;
  if (error) return <div className="text-center py-10 text-red-500">{error}</div>;

  return (
    <div className="container mx-auto px-4 py-8 text-center">
      <h1 className="text-4xl font-bold text-green-400 mb-4">Płatność zakończona sukcesem!</h1>
      <p className="text-lg text-gray-300">Dziękujemy za zakup. Szczegóły transakcji:</p>
      {session && (
        <div className="bg-gray-800 rounded-lg shadow-lg p-6 mt-6 max-w-md mx-auto">
          <p><strong>ID Płatności:</strong> {session.payment_intent}</p>
          <p><strong>Kwota:</strong> {(session.amount_total / 100).toFixed(2)} {session.currency.toUpperCase()}</p>
        </div>
      )}
    </div>
  );
};

export default PaymentSuccessPage;